import React, { useEffect, useState } from "react";
import "./RightDrawerComponent.scss";
import { useTypedDispatch, useTypedSelector } from "hooks/store";
import {
    CurrentDrawerOpenType,
    toggleDrawer,
    updateDrawerTitle,
} from "state/slices/RightDrawerSlice";
import ArrowBackIosOutlinedIcon from "@mui/icons-material/ArrowBackIosOutlined";
import { IconButton } from "@mui/material";
import AddEditObjectComponent from "./AddEditObjectComponent";
import BSUObjectComponent from "./BSUObjectComponent";
import BSUPortComponent from "./BSUPortComponent";
import CMRConsoleComponent from "./CMRConsoleComponent";
import DrawerBedComponent from "./DrawerBedComponent";
import DrawerStackComponent from "./DrawerStackComponent";
import DrawerTrolleyComponent from "./DrawerTrolleyComponent";
import DrawerAnesthesiaComponent from "./DrawerAnesthesiaComponent";
import DrawerSurgeonComponent from "./DrawerSurgeonComponent";
import DrawerSlaveComponent from "./DrawerSlaveComponent";
import DrawerAccessPointComponent from "./DrawerAccessPointComponent";
import fn from "utils/function";

const RightDrawerComponent = (): JSX.Element => {
    const isOpen = useTypedSelector((store) => store.ModelWindow.isModelOpen);
    const modelTitle = useTypedSelector((store) => store.ModelWindow.modelTitle);
    const currentModel = useTypedSelector<CurrentDrawerOpenType>((store) => store.ModelWindow.type);
    const [device, setDevice] = useState("desktop");
    const dispatch = useTypedDispatch();
    useEffect(() => {
        detectDevice();
    }, [isOpen]);

    const handleToggleModel = (): void => {
        detectDevice();
        if (isOpen) {
            dispatch(toggleDrawer(currentModel));
        } else {
            dispatch(toggleDrawer(CurrentDrawerOpenType.AddObject));
            dispatch(updateDrawerTitle("Select a New Item to place into the OR"));
        }
    };
    const detectDevice = (): void => {
        if (fn.isMobile()) {
            setDevice("mobile");
            return;
        }
        if (device !== "desktop") {
            setDevice("desktop");
        }
    };

    const updateBody = () => {
        if (CurrentDrawerOpenType.AddObject === currentModel) {
            return <AddEditObjectComponent device={device} />;
        }
        if (CurrentDrawerOpenType.BSUObject === currentModel) {
            return <BSUObjectComponent />;
        }
        if (CurrentDrawerOpenType.Port === currentModel) {
            return <BSUPortComponent />;
        }
        if (CurrentDrawerOpenType.Stack === currentModel) {
            return <DrawerStackComponent />;
        }
        if (CurrentDrawerOpenType.Console === currentModel) {
            return <CMRConsoleComponent />;
        }
        if (CurrentDrawerOpenType.Trolley === currentModel) {
            return <DrawerTrolleyComponent />;
        }
        if (CurrentDrawerOpenType.Anesthesia === currentModel) {
            return <DrawerAnesthesiaComponent />;
        }
        if (CurrentDrawerOpenType.Surgeon === currentModel) {
            return <DrawerSurgeonComponent />;
        }
        if (CurrentDrawerOpenType.Slave === currentModel) {
            return <DrawerSlaveComponent />;
        }
        if (CurrentDrawerOpenType.AccessPoint === currentModel) {
            return <DrawerAccessPointComponent />;
        }
        if (CurrentDrawerOpenType.Bed === currentModel) {
            return <DrawerBedComponent />;
        }
    };

    return (
        <aside id="drawerWrapper">
            <section
                className={`drawerWindow ${isOpen ? "open" : ""} ${device} ${currentModel}`}
                id="drawerWindow"
            >
                <nav className="drawerOpener">
                    <IconButton onClick={handleToggleModel} className="openDrawer">
                        <ArrowBackIosOutlinedIcon className="backArrow" />
                    </IconButton>
                </nav>

                <header className="onlyDesktop">
                    <h2>{modelTitle}</h2>
                </header>

                <section>{updateBody()}</section>
            </section>
        </aside>
    );
};

export default RightDrawerComponent;
